/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OrderBottomIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Order Bottom',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m5.49414,15.56445l-2,1.75c-.2832.24805-.70508.24805-.98828,0l-2-1.75c-.31152-.27246-.34277-.74707-.07031-1.05859.27441-.31152.74707-.34082,1.05859-.07031l.75586.66162V2.75c0-.41406.33594-.75.75-.75s.75.33594.75.75v12.34717l.75586-.66162c.14258-.12402.31836-.18555.49414-.18555.20801,0,.41602.08691.56445.25586.27246.31152.24121.78613-.07031,1.05859Z"
      fill="currentColor"
    />
    <path
      d="m13.09473,11.79297c-.05859-.04102-.12988-.04004-.18848-.00098l-3.80371,2.62598c-.09277.06445-.10254.16992-.10254.21289s.00977.14844.10254.21289l3.80371,2.62598c.06055.04102.12695.04102.1875,0l3.80371-2.62598c.09277-.06445.10254-.16992.10254-.21289s-.00977-.14844-.10254-.21289l-3.80273-2.625Z"
      fill="currentColor"
      opacity=".2"
    />
    <path
      d="m17.74902,13.18359l-3.80371-2.62598c-.28711-.19727-.61621-.29688-.94531-.29688s-.65723.09863-.94434.2959l-.00098.00098-3.80371,2.62598c-.4707.32422-.75098.86523-.75098,1.44727s.28027,1.12305.75098,1.44727l3.80371,2.62598c.57422.39648,1.31641.39648,1.89062,0l3.80371-2.62598c.4707-.32422.75098-.86523.75098-1.44727s-.28027-1.12305-.75098-1.44727Zm-.85156,1.66016l-3.80371,2.62598c-.06055.04102-.12695.04102-.1875,0l-3.80371-2.62598c-.09277-.06445-.10254-.16992-.10254-.21289s.00977-.14844.10254-.21289l3.80371-2.62598c.05859-.03906.12988-.04004.18848.00098l3.80273,2.625c.09277.06445.10254.16992.10254.21289s-.00977.14844-.10254.21289Z"
      fill="currentColor"
    />
    <path
      d="m13,5.64844c-.32812,0-.65625.09766-.94336.29395l-3.80371,2.60156c-.42676.29199-.69727.75879-.74219,1.28027-.0459.53125.14355,1.04492.51855,1.41016.29883.29004.77344.28125,1.06055-.01367.28906-.29688.2832-.77246-.01367-1.06055-.05176-.05078-.07812-.12793-.07129-.20703.00391-.05078.02441-.12207.09473-.1709l3.80469-2.60156c.05859-.04102.13281-.04102.19141,0l3.80371,2.60156c.07129.04883.0918.12012.0957.1709.00684.0791-.01953.15625-.07129.20703-.29688.28809-.30273.76367-.01367,1.06055.28809.29492.7627.30371,1.06055.01367.375-.36523.56445-.87891.51855-1.41016-.04492-.52148-.31543-.98828-.74316-1.28027l-3.80273-2.60156c-.28711-.19629-.61523-.29395-.94336-.29395Z"
      fill="currentColor"
    />
    <path
      d="m13,.99902c-.32812,0-.65625.09766-.94141.29199l-3.80566,2.60254c-.42676.29199-.69727.75781-.74219,1.2793-.04688.53125.14258,1.0459.51855,1.41211.29688.28809.77148.2832,1.06055-.01367.28906-.2959.2832-.77148-.01367-1.06055-.05176-.05078-.07812-.12793-.07129-.20801.00391-.05078.02441-.12305.09473-.1709l3.80469-2.60156c.05859-.04102.13086-.04199.19336.00098l3.80176,2.60059c.07129.04785.0918.12012.0957.1709.00684.08008-.01953.15723-.07129.20801-.29688.28906-.30273.76465-.01367,1.06055.29004.29688.76465.30176,1.06055.01367.37598-.36621.56543-.88086.51855-1.41211-.04492-.52148-.31543-.9873-.74316-1.2793l-3.80273-2.60156c-.28711-.19531-.61523-.29297-.94336-.29297Z"
      fill="currentColor"
    />
  </svg>`;
};
